import "./Navbar.scss";
import logo2 from "/src/app/assets/logo-mini.png"
import logo from "/src/app/assets/logo.png";
import {Link, useLocation} from "react-router-dom";
import {useEffect} from "react";
import {useUserStore} from "../../../../../modules/shop/user/store";
import {PATHS, PATHS_API} from "../../../../../enum";
import ThemeSwitcher from "../ThemeSwitcher/ThemeSwitcher";
import {CHILD_PROFILE_PATHS} from "../../../ProfilePage/components/Sidebar/Sidebar";
import DepositWallet from "../../../../shared/UIComponents/DepositWallet/DepositWallet";
import NotificationBell from "./components/NotificationBell/NotificationBell";
import BurgerButton from "./components/BurgerButton/BurgerButton";
import {useI18n} from "../../../../i18n/I18nProvider";

const Navbar = () => {
    const { t } = useI18n()
    const user = useUserStore(state => state.user)
    const fetchUser = useUserStore(state => state.fetchUser)
    const location = useLocation();
    const onStatsPage = location.pathname.startsWith("/stats");

    useEffect(() => {
        fetchUser()
    }, [])

    return (
        <div className="wrapper-fake">
            <div className="wrapper">
                <nav className="navbar">
                    <Link className="navbar-brand" to={PATHS.SHOP}>
                        {/*<img className="navbar-logo" src={logo} alt="logo"/>*/}
                        <h4 className="navbar-logo">ASKOLD</h4>

                        {/*<img className="navbar-logo-mini" src={logo2} alt="logo"/>*/}
                    </Link>
                    { onStatsPage
                        ?
                        <Link className="navbar-stats" to={PATHS.SHOP} title={t("nav.shop")} aria-label={t("nav.shop")}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0" />
                            </svg>
                            <span className="navbar-stats-text">{t("nav.shop")}</span>
                        </Link>
                        :
                        <Link className="navbar-stats navbar-stats-leaders" to="/stats" title={t("nav.topPlayers")} aria-label={t("nav.topPlayers")}>
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5L3 8zm2.4 13h13.2v-1.6H5.4V21z" />
                            </svg>
                            <span className="navbar-stats-text">{t("nav.leaders")}</span>
                        </Link>
                    }
                    <div className="wrapper-theme-switcher">
                        {/*<ThemeSwitcher />*/}
                        {/*<button onClick={ff}>set</button>*/}
                    </div>
                    {
                        location.pathname.startsWith(PATHS.PROFILE)
                            ?
                                <>
                                    {/*<NotificationBell />*/}
                                    <DepositWallet user={user} />
                                    <div className="profile-info">
                                        <img
                                            className="avatar-profile"
                                            src={user.avatarUrl}
                                            alt="avatar"
                                        />
                                        <div className="name-profile">
                                            { user.personaName }
                                        </div>
                                    </div>
                                    <BurgerButton />
                                </>
                            :
                            user?._id ?
                                <>
                                    {/*<NotificationBell />*/}
                                    <DepositWallet user={user} />
                                    <Link className='btn profile-btn' to={PATHS.PROFILE + CHILD_PROFILE_PATHS.BASKET}>
                                        {t("nav.profile")}
                                    </Link>
                                    <BurgerButton />
                                </>
                                :
                                <>
                                    <a style={{"textDecoration" : "none", marginLeft: "auto"}} className='btn profile-btn' href={PATHS_API.LOGIN}>
                                        {t("nav.login")}
                                    </a>
                                    <BurgerButton />
                                </>
                    }
                </nav>
            </div>
        </div>
    );
};

export default Navbar;